import { Chip } from "@mui/material";

/**
 * Mapa de texto legível por status.
 * Mantém os mesmos textos do componente original.
 */
const statusText: Record<string, string> = {
  cancelled: "Cancelado",
  proposed: "Proposta",
  pending: "Pendente de pagamento",
  arrived: "Confirmado",
  booked: "Confirmado",
  valid: "Ativo",
  expired: "Expirado",
  stopped: "Interrompido",
  active: "Solicitado",
  draft: "Solicitado",
  completed: "Finalizado",
  result: "Realizado",
};

// Textos específicos do manager de questionários
const questionnaireText: Record<string, string> = {
  ...statusText,
  active: "Ativo",
  draft: "Rascunho",
  unknown: "Arquivado",
};

/**
 * Cores de fundo por status — usa os tokens customizados do projeto
 * (error400, primary300, neutral300, warning300, success300, primary100).
 * O texto sempre usa neutral1000 para contraste garantido.
 */
const statusBgColor: Record<string, string> = {
  cancelled: "error400.main",
  stopped:   "neutral300.main",
  proposed:  "neutral300.main",
  pending:   "warning600.main",
  arrived:   "primary300.main",
  booked:    "primary300.main",
  result:    "primary300.main",
  valid:     "primary300.main",
  expired:   "neutral300.main",
  draft:     "warning300.main",
  active:    "warning300.main",
  completed: "none",
};

// Variante questionário: active = verde, draft = cinza, unknown = azul claro
const questionnaireBgColor: Record<string, string> = {
  ...statusBgColor,
  active:  "success300.main",
  draft:   "neutral300.main",
  unknown: "primary100.main",
};

export type StatusRowVariant = "default" | "questionnaire";

export interface StatusRowProps {
  status: string;
  variant?: StatusRowVariant;
}

export function StatusRow({ status, variant = "default" }: StatusRowProps) {
  const textMap  = variant === "questionnaire" ? questionnaireText  : statusText;
  const bgMap    = variant === "questionnaire" ? questionnaireBgColor : statusBgColor;

  const label   = textMap[status] ?? status;
  const bgcolor = bgMap[status]   ?? "neutral200.main";
  /** pending: laranja do dashboard; proposed permanece cinza (default). */
  const isOrangeStatus = status === "pending";

  return (
    <Chip
      label={label}
      size="small"
      sx={{
        fontWeight: 600,
        fontSize: "0.68rem",
        letterSpacing: "0.02em",
        color: isOrangeStatus ? "neutral0.main" : "neutral1000.main",
        bgcolor,
        border: "none",
        height: 22,
        maxWidth: "100%",
        "& .MuiChip-label": { px: 1 },
      }}
    />
  );
}
